export const SocialUIProviders = {
  FACEBOOK: 'facebook',
  GMB: 'gmb',
  YELP: 'yelp'
};

export const SOCIAL_UI_ENABLED_PROVIDERS = [
  SocialUIProviders.FACEBOOK,
  SocialUIProviders.GMB,
  SocialUIProviders.YELP
];

export const SocialUIConnectEvents = {
  CONNECT_REQUESTED: 'SOCIAL_UI_CONNECT_REQUESTED'
};

export const isSocialUIEnabled = provider => {
  return SOCIAL_UI_ENABLED_PROVIDERS.includes(provider);
};

export const shouldUseSocialUI = (provider, isReseller, renderMode) => {
  return isSocialUIEnabled(provider) && !isReseller && renderMode === 'EDIT';
};
